import { ResponseMapType } from "@dashboard/common/types";

type PlaceResult = google.maps.places.PlaceResult;

export const getDataFromGeoCoderResult = (
  geoCoderResponse: google.maps.GeocoderResult[]
) => {
  const geoCoderResponseHead = geoCoderResponse[0];
  const geoCoderData = geoCoderResponseHead.address_components;
  const isEmptyData = !geoCoderResponseHead || !geoCoderData;

  if (isEmptyData) return {};

  let localityOptional = "";
  const data = geoCoderData?.reduce(
    (acc, { types, long_name: value }) => {
      const type = types[0];

      switch (type) {
        case "route":
          return { ...acc, route: value };
        case "locality":
          return { ...acc, locality: value };
        case "country":
          return { ...acc, country: value };
        case "postal_code_prefix":
          return { ...acc, postalCodePrefix: value };
        case "street_number":
          return { ...acc, streetNumber: value };
        default:
          if (type === "administrative_area_level_1") {
            localityOptional = value;
          }
          return acc;
      }
    },
    { locality: "" }
  );

  if (!data.locality) {
    data.locality = localityOptional;
  }

  return data;
};

export const createGeocodedResult = (
  latLng: google.maps.LatLng | google.maps.LatLngLiteral,
  place?: PlaceResult
): Promise<ResponseMapType> => {
  const geocoder: google.maps.Geocoder = new window.google.maps.Geocoder();
  const coords: google.maps.LatLngLiteral | google.maps.LatLngLiteral =
    latLng instanceof google.maps.LatLng ? latLng.toJSON() : latLng;

  return new Promise((resolve) => {
    if (geocoder) {
      geocoder.geocode(
        { location: latLng },
        (result: google.maps.GeocoderResult[] | null, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            const geocoderResult = result as google.maps.GeocoderResult[];
            const localityData = getDataFromGeoCoderResult(geocoderResult);
            const fullAddress =
              place?.formatted_address || geocoderResult[0]?.formatted_address;
            resolve({ coords, fullAddress, ...localityData });
          }
        }
      );
    }
  });
};
